import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CountUp from 'react-countup';

import axios from 'axios';

const TrackSection = () => {
    const [trackingId, setTrackingId] = useState('');
    const [checking, setChecking] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const tid = trackingId.trim();
        if (!tid) return;

        setChecking(true);
        setError(null);

        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/order-details/tracking/ofl/${encodeURIComponent(tid)}`);
            if (response.data && response.data.order) {
                setTrackingId('');
                navigate(`/tracking?id=${encodeURIComponent(tid)}`);
            } else {
                setError('Invalid tracking number. Please verify and try again.');
            }
        } catch (err) {
            console.error(err);
            setError('Invalid tracking number. Please verify and try again.');
        } finally {
            setChecking(false);
        }
    };

    return (
        <section className="wpo-track-section">
            <div className="container">
                <div className="cta-wrap">
                    <div className="tracking">
                        <h2>Track your shipment</h2>
                        <form onSubmit={handleSubmit}>
                            <input
                                type="text"
                                placeholder="Enter tracking ID or order number"
                                value={trackingId}
                                onChange={(e) => {
                                    setTrackingId(e.target.value);
                                    if (error) setError(null);
                                }}
                                disabled={checking}
                            />
                            <button type="submit" className="theme-btn" disabled={checking}>
                                {checking ? 'Checking...' : 'Track order'}
                            </button>
                        </form>
                        {error && (
                            <div className="section-error-message mt-2" style={{ color: '#EF4444', fontSize: '14px', fontWeight: '500' }}>
                                {error}
                            </div>
                        )}
                    </div>
                    <ul className="funfact">
                        <li>
                            <h2><CountUp end={853} enableScrollSpy />+</h2>
                            <p>Countries
                                Represented</p>
                            <div className="shape">
                                <svg viewBox="0 0 213 216" fill="none">
                                    <path d="M0 0H213V216H0V0Z" fill="white" fillOpacity="0.07" />
                                </svg>
                            </div>
                        </li>
                        <li>
                            <h2><CountUp end={32} enableScrollSpy />+</h2>
                            <p>Countries Covered</p>
                            <div className="shape">
                                <svg viewBox="0 0 213 216" fill="none">
                                    <path d="M0 0H213V216H0V0Z" fill="#281D1D" fillOpacity="0.07" />
                                </svg>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default TrackSection;